import type { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@apollo/client';

import type {
  XcpTeampermissionsUserResourcesQueryVariables,
  XcpTeampermissionsUserResourcesQuery,
} from '../../graphql/queries/teampermissions-user-resources.gql-types';
import { XcpTeampermissionsUserResourcesDocument } from '../../graphql/queries/teampermissions-user-resources.gql-types';

const useTeampermissionsUserResources = (
  variables: XcpTeampermissionsUserResourcesQueryVariables = {},
  options: QueryHookOptions<XcpTeampermissionsUserResourcesQuery> = {}
) => {
  const { error, ...rest } = useQuery(XcpTeampermissionsUserResourcesDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
    ...options,
  });

  return {
    error,
    ...rest,
  };
};

export { useTeampermissionsUserResources };
